<template>
  <div>
    <b-card class="standardpage">
      <b-card-header v-if="selectedComponent == null">
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="allcodes.icon" class="mr-1"></i>
            <span>{{ allcodes.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-if="selectedComponent == null" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-4">
            <div class="row">
              <div v-for="(code, index) in allcodes.items" :key="index" class="col-6">
                <b-list-group-item button :pressed="selectedComponent == code.component"
                  @click="selectedComponent = code.component">
                  <b-row align-v="center">
                    <b-col cols="auto"><i :class="code.icon"></i></b-col>
                    <b-col cols="10">
                      <span class="h5">{{ code.label }}</span>
                      <div>
                        <span>{{ code.description }}</span>
                      </div>
                    </b-col>
                  </b-row>
                </b-list-group-item>
              </div>
            </div>

          </b-card-body>
        </b-card>
      </div>

      <div>
        <component :is="selectedComponent" @discard="selectedComponent = null" />
      </div>
    </b-card>
  </div>
</template>


<script>
import gql from "graphql-tag";

import BookerInitials from "./Setup_BookerInitials.vue";
import ClientsGroups from "./Setup_ClientsGroups";
import Clients from "./Setup_Clients";
import EMDTypes from "./Setup_EMDTypes";
import Events from "./Setup_Events";
import BookingPaymentMethods from "./Setup_BookingPaymentMethods";
import BookingPaymentReasons from "./Setup_BookingPaymentReasons";
import Currencies from "./Setup_Currencies";
import TravellerProfiles from "./Setup_TravellerProfiles";
import Airports from "./Setup_Airports";
import Countries from "./Setup_Countries";
import Aircrafts from "./Setup_Aircrafts";
import Airlines from "./Setup_Airlines";
import FlightsClasses from "./Setup_FlightsClasses";
import FlightsClassesExceptions from "./Setup_FlightsClassesExceptions";
import TravellerMetaTags from "./Setup_TravellerMetaTags";
import Suppliers from "./Setup_Suppliers";
import OrdersReasons from "./Setup_OrdersReasons";
import TicketingFees from "./Setup_TicketingFees";
//import TicketingScripts from "./Setup_TicketingScripts";
import Budgets from "./Setup_Budgets.vue";
import SalesGroups from "./Setup_SalesGroups";
import RoutingNames from "./Setup_RoutingNames.vue";
import MIFields from "./Setup_MIFields";
import SupplierTypes from "./Setup_SupplierTypes";

function dynamicSort(property) {
  var sortOrder = 1;

  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }

  return function (a, b) {
    if (sortOrder == -1) {
      return b[property].localeCompare(a[property]);
    } else {
      return a[property].localeCompare(b[property]);
    }
  };
}


export default {
  name: "Setup",
  components: {
    Budgets,
    BookerInitials,
    ClientsGroups,
    BookingPaymentMethods,
    BookingPaymentReasons,
    Clients,
    Currencies,
    //   ClientAccountTypes,
    EMDTypes,
    Events,
    //   SalesGroups,
    //   TransactionTypes,
    TravellerMetaTags,
    TravellerProfiles,
    TicketingFees,
    SupplierTypes,
    //TicketingScripts,
    //   ZoneCharges,
    //   BLSupplierType,
    Countries,
    Airports,
    Aircrafts,
    Airlines,
    FlightsClasses,
    FlightsClassesExceptions,
    Suppliers,
    // VATRates
    OrdersReasons,
    SalesGroups,
    RoutingNames,
    MIFields
  },

  data() {
    return {
      selectedComponent: null,
      allcodes:
      {
        title: "Setup All",
        icon: "fa fa-cogs",
        debounce: 500,
        items: [],
      }
      //   items: [
      //     {
      //       icon: "fa fa-list text-primary mr-1 fa-2x",
      //       label: "Accounting Codes",
      //       description: "Accounting codes classify events into sport types.",
      //       component: "AccountingCodes",
      //     },
      //     {
      //       icon: "fa fa-list text-primary mr-1 fa-2x",
      //       label: "Booker Names",
      //       description: "Booker Names...",
      //       component: "BookerInitials",
      //     },
      //     {
      //       icon: "fa fa-list text-primary mr-1 fa-2x",
      //       label: "Booking Payment Methods",
      //       description: "Booking Payment Methods...",
      //       component: "BookingPaymentMethods",
      //     },
      //     {
      //       icon: "fa fa-list text-primary mr-1 fa-2x",
      //       label: "Currencies",
      //       description: "List of major currencies.",
      //       component: "Currencies",
      //     },
      //     {
      //       icon: "fa fa-list text-primary mr-1 fa-2x",
      //       label: "Client Account Types",
      //       description: "Client Account Types...",
      //       component: "ClientAccountTypes",
      //     },
      //     {
      //       icon: "fa fa-list text-primary mr-1 fa-2x",
      //       label: "Supplier Types",
      //       description: "Supplier Type...",
      //       component: "BLSupplierType",
      //     },

      //     {
      //       icon: "fa fa-list text-primary mr-1 fa-2x",
      //       label: "Sales Groups",
      //       description: "Sales Groups...",
      //       component: "SalesGroups",
      //     },

      //     {
      //       icon: "fa fa-list text-primary mr-1 fa-2x",
      //       label: "Transaction Types",
      //       description: "Transaction Types...",
      //       component: "TransactionTypes",
      //     },

      //     {
      //       icon: "fa fa-list text-primary mr-1 fa-2x",
      //       label: "Traveller Meta Tags",
      //       description: "Use to annotate travellers in various reports (AGSPT) with extra data attributes.",
      //       component: "TravellerMetaTags",
      //     },
      //     {
      //       icon: "fa fa-list text-primary mr-1 fa-2x",
      //       label: "Ticketing Fees",
      //       description: "Default and region client ticketing fees for published tickets.",
      //       component: "TicketingFees",
      //     },

      //     // {
      //     //     icon: "fa fa-star mr-1",
      //     //     label: "Zone Charges",
      //     //     description: "Zone Charges...",
      //     //     component: "ZoneCharges"
      //     // },
      //   ],
      // },

    };
  },
  async mounted() {
    await this.load()
  },
  methods: {
    async load() {

      let variables = {
        name: "setup",
      };
      console.log("variables", variables);

      this.busy = true;

      try {
        const response = await this.$apollo.query({
          query: gql`
              query setup_systemsettings($name: String) {
                setup_systemsettings(name: $name) {
                  data
                }
              }
            `,
          variables,
        });


        this.allcodes.items = JSON.parse(response.data.setup_systemsettings[0].data);
        this.allcodes.items.sort(dynamicSort('label'))

      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },

  }


};
</script>

<style></style>